import { useState, useEffect } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { TenantUserRoleReadModel, UserReadModel } from '@client/api';
import { Modal, ModalContent, IconButton } from '@client/toolkit';
import { SelectedTenant, TenantSelectionEnum } from '../../../redux';
import { HiX } from 'react-icons/hi';
import ExioLogo from '../../../assets/images/logo_exio.svg?react';
import { TenantsSelectionDropdown } from '../../../components/tenants-selection-dropdown/tenants-selection-dropdown';

interface TenantSelectionModalProps {
  allowedTenants: TenantUserRoleReadModel[];
  selectedTenant: SelectedTenant | null;
  user: UserReadModel | null;
  onChange?: (tenant: SelectedTenant) => void;
  onClose: () => void;
  open: boolean;
}

export function TenantSelectionModal({ allowedTenants, user, onClose, open }: TenantSelectionModalProps) {
  const { t } = useTranslation('common');

  const handleClose = () => {
    onClose();
  };

  if (allowedTenants.length <= 1) {
    return null;
  }

  const userName = user?.person?.name || user?.email || '';
  return (
    <Modal open={open} onClose={handleClose} onBackdropClick={handleClose} size="sm">
      <ModalContent className="p-6 space-y-4">
        <div className="text-right">
          <IconButton size="sm" onClick={handleClose}>
            <HiX />
          </IconButton>
        </div>
        <div className="m-8">
          <ExioLogo className="mb-11 h-20 w-full text-center" />
          <h2 className="text-xl text-primary mb-4">{t('tenantSelection.welcomeTitle', { name: userName })}</h2>
          <p className="text-primary mb-10">{t('tenantSelection.description')}</p>
          <TenantsSelectionDropdown onChanged={handleClose} />
          <p className="text-primary mt-10 mb-16">
            <Trans i18nKey="tenantSelection.instruction" components={[<span className="text-brand-primary" />]} />
          </p>
        </div>
      </ModalContent>
    </Modal>
  );
}
